import type { CampaignChapter } from '../model/campaign-mock';

import { DifficultyMeter } from '@shared/ui/difficulty-meter';

export const ChapterDifficulty = ({ difficulty }: Pick<CampaignChapter, 'difficulty'>) => (
  <DifficultyMeter value={difficulty} label="Сложность главы" />
);
